(() => {
  const loader = document.querySelector('[data-page-loader]');
  if (!loader || window.Shopify?.designMode) return;

  const main = document.getElementById('MainContent');
  let revealTimer;
  let recoveryTimer;
  let pending = false;
  let active = false;

  const hide = () => {
    clearTimeout(revealTimer);
    clearTimeout(recoveryTimer);
    pending = false;
    active = false;
    if (typeof loader.hidePopover === 'function' && loader.matches(':popover-open')) loader.hidePopover();
    loader.hidden = true;
    main?.removeAttribute('aria-busy');
  };

  const show = () => {
    if (!pending || active) return;
    active = true;
    loader.hidden = false;
    if (typeof loader.showPopover === 'function') loader.showPopover();
    main?.setAttribute('aria-busy', 'true');
  };

  const begin = () => {
    if (pending) return;
    pending = true;
    revealTimer = setTimeout(show, 180);
    recoveryTimer = setTimeout(hide, 8000);
  };

  const isPageNavigation = (href) => {
    let url;
    try {
      url = new URL(href, window.location.href);
    } catch {
      return false;
    }
    if (url.origin !== window.location.origin || !/^https?:$/.test(url.protocol)) return false;
    if (url.pathname === location.pathname && url.search === location.search) return false;
    if (/\/(?:cart|checkout|checkouts|account|accounts|challenge|password|discount|admin)(?:\/|$)/.test(url.pathname)) return false;
    if (/\.(?:pdf|zip|csv|json|xml|jpe?g|png|webp|gif|svg|mp4|glb)$/i.test(url.pathname)) return false;
    return true;
  };

  window.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || link.hasAttribute('download') || link.closest('[data-page-loader-ignore]')) return;
    const target = link.getAttribute('target') || document.querySelector('base[target]')?.getAttribute('target');
    if (target && target.toLowerCase() !== '_self') return;
    if (isPageNavigation(link.href)) {
      queueMicrotask(() => {
        if (!event.defaultPrevented) begin();
      });
    }
  });

  window.navigation?.addEventListener('navigate', (event) => {
    if (event.hashChange || event.formData || event.downloadRequest != null || event.destination.sameDocument) return;
    if (isPageNavigation(event.destination.url)) {
      begin();
      event.signal?.addEventListener('abort', hide, { once: true });
    }
  });
  window.navigation?.addEventListener('navigateerror', hide);
  window.navigation?.addEventListener('navigatesuccess', hide);
  window.addEventListener('pageshow', hide);
  window.addEventListener('pageswap', (event) => {
    if (pending || active) event.viewTransition?.skipTransition();
  }, { capture: true });
  window.addEventListener('pagehide', hide);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') hide();
  });
})();
